import request from 'src/shared/utils/requester';

const uploadFile = async (url, file) => {
  const method = 'POST';

  const json = await request({ method, url, file });
  return json;
};

export default uploadFile;
